<template>
  <div class="fz-sidebar__menu">
    <SfList>
      <SfListItem
        :style="{ '--list-item-margin': '24px 0' }"
        v-for="item in navigation"
        :key="item.name"
      >
        <router-link :to="item.path" v-slot="{ href, route, navigate, isActive }">
          <SfMenuItem
            class="menu-item"
            @click="navigateWithClose(navigate, $event)"
            :label="$t(item.name)"
            :class="{ 'sf-menu-item--is-active': isActive }"
          />
        </router-link>
      </SfListItem>
      <SfListItem
        :style="{ '--list-item-margin': '24px 0' }"
        v-for="item in includeInTopMenu"
        :key="item.SeName"
      >
        <router-link :to="`/p/${item.SeName}`" v-slot="{ href, route, navigate, isActive }">
          <SfMenuItem
            class="menu-item"
            @click="navigateWithClose(navigate, $event)"
            :label="item.Title"
            :class="{ 'sf-menu-item--is-active': isActive }"
          />
        </router-link>
      </SfListItem>
    </SfList>
  </div>
</template>
<script>
import { SfList, SfMenuItem } from '@storefront-ui/vue';
import { pages } from '@/modules/page';

import routes from '../../mixins/routes';
import sidebar from '../../mixins/sidebar';

export default {
  name: 'MenuSidebarContent',
  mixins: [routes, sidebar, pages],
  components: {
    SfList,
    SfMenuItem,
  },
};
</script>
<style lang="scss" scoped>
.menu-item {
  text-align: left;
}
</style>
